import { createSlice } from "@reduxjs/toolkit";

const orderSlice = createSlice({
  name: "order",
  initialState: {
    customerInfo: null,
    orderId: "",
    orderInfo: null,
    ticketId: "",
  },
  reducers: {
    resetOrder(state, action) {
      state.customerInfo = null;
      state.orderId = "";
      state.orderInfo = null;
      state.ticketId = "";
    },
    setTicketId(state, action) {
      state.ticketId = action.payload;
    },

    setCustomerInfoFromApi(state, action) {
      state.customerInfo = {
        fullName: action.payload.fullName,
        phoneNumber: action.payload.phoneNumber,
        email: action.payload.email,
        uniqId: action.payload.uniqId,
        address: action.payload.address,
        taxCode: action.payload.taxCode,
        cusCode: action.payload.cusCode,
        isForeign: action.payload.isForeign,
        quocGiaId: action.payload.quocGiaId,
        tinhThanhId: action.payload.tinhThanhId,
      };
    },

    setCustomerInfo(state, action) {
      state.customerInfo = {
        fullName: action.payload.fullName,
        phoneNumber: action.payload.phoneNumber,
        email: action.payload.email,
        uniqId: action.payload.uniqId,
        address: action.payload.diachi,
        taxCode: action.payload.msthue,
        cusCode: action.payload.cusCode,
        isForeign: action.payload.isForeign,
        quocGiaId: action.payload.quocGiaId,
        tinhThanhId: action.payload.tinhThanhId,
      };
    },
    setOrderId(state, action) {
      state.orderId = action.payload;
    },
    setOrderInfoV2(state, action) {
      state.orderInfo = {
        id: action.payload.id,
        totalPrice: action.payload.totalPrice,
        fullName: action.payload.fullName,
        phoneNumber: action.payload.phoneNumber,
        email: action.payload.email,
        uniqId: action.payload.uniqId,
        payStatus: action.payload.payStatus,
        ticketId: action.payload.ticketId,
        isCash: action.payload.isCash,
        paymentId: action.payload.paymentId,
      };
    },
    setOrderInfo(state, action) {
      const placeSet = new Set();
      const customerTypeSet = new Set();
      const placeArr = [];
      const customerTypeArr = [];
      // console.log(action.payload.ticketPlaceDetails)
      action.payload.ticketDetailReturn.forEach((el) => {
        placeSet.add(el.ticketTypeId);
        customerTypeSet.add(el.customerType);
      });
      [...customerTypeSet].forEach((el) => {
        const obj = {
          customerTypeName: "",
          customerType: el,
          quantity: 0,
        };

        action.payload.ticketDetailReturn.forEach((elDt) => {
          if (elDt.customerType === el) {
            obj.customerTypeName = elDt.customerTypeName;
            obj.quantity = obj.quantity + elDt.quantity;
          }
        });

        customerTypeArr.push(obj);
      });
      [...placeSet].forEach((el) => {
        const placeObj = {
          placeId: el,
          details: [],
          totalPrice: 0,
          numberOfDayCanUse: 99,
        };
        action.payload.ticketDetailReturn.forEach((elDt) => {
          if (elDt.ticketTypeId === el) {
            placeObj.name = elDt.placeName;
            placeObj.details.push({
              customerType: elDt.customerType,
              quantity: elDt.quantity,
              customerTypeName: elDt.customerTypeName,
              unitPrice: elDt.unitPrice,
            });
            placeObj.totalPrice += elDt.unitPrice * elDt.quantity;
            placeObj.numberOfDayCanUse = elDt.numberOfDayCanUse;
            placeObj.listPlaceName = elDt.listPlaceName;
            placeObj.typeValue = elDt.typeValue;
          }
        });
        placeArr.push(placeObj);
      });
      // console.log(placeSet)
      // console.log(placeArr)

      state.orderInfo = {
        id: action.payload.id,
        totalPrice: action.payload.totalPrice,
        fullName: action.payload.fullName,
        phoneNumber: action.payload.phoneNumber,
        email: action.payload.email,
        uniqId: action.payload.uniqId,
        payStatus: action.payload.payStatus,
        ticketId: action.payload.ticketId,
        ticketPlaceDetails: placeArr,
        customerTypeDetails: customerTypeArr,
        isCash: action.payload.isCash,
        paymentId: action.payload.paymentId,
        invoiceFid: action.payload.invoiceFid,
        invStatus: action.payload.invStatus,
        payType: action.payload.payType,
        isTourGuideTicket: action.payload.isTourGuideTicket,
        createdTime: action.payload.createdDate,
        createdBy: action.payload?.createdBy,
        eventTime: action.payload.eventTime,
      };
    },
  },
});

export const orderActions = orderSlice.actions;

export default orderSlice;
